module.exports = __webpack_public_path__ + "img/basisgedrag.570fb0f1.png";